import { ReportRow } from 'wb-reddit/app/routes/reports/utils';
import { ReportApiFiltersOptionsAction } from 'wb-reddit/graphql/generated';
import { SpotifyReportSchedule } from 'wb-spotify/app/common/utils';
import { SpotifyReportsQueryItems } from 'wb-spotify/graphql/generated';

export function processSpotifyReport(spotifyReport: SpotifyReportsQueryItems): ReportRow {
	return {
		...spotifyReport,
		// @ts-ignore THis is not used in spotify reports
		reportDateType: SpotifyReportSchedule.EveryMonday,
		id:             spotifyReport.reportId,
		reportApi:      {
			reportApiFiltersOptions: (spotifyReport.reportFiltersOptions ?? []).flatMap(
				option => {
					if (!option) return [];

					return {
						...option,
						__typename: 'ReportApiFiltersOptionsType',
						// Should be fine to typecast as both enums are the same
						action:     option.action as unknown as ReportApiFiltersOptionsAction,
					};
				},
			),
			// TODO not sure is it the same as apiMetrics, but we don't have it on BE for now
			// without it we can't edit/view existing reports
			reportApiMetrics:    spotifyReport.reportMetrics,
			reportApiDimensions: spotifyReport.reportDimensions,
			reportApiFilters:    '',
			reportApiToken:      spotifyReport.reportToken,
		},
		owner: {
			id:           '',
			userEmail:    '',
			userFullName: '',
		},
	};
}
